<template>
  <div class="content">
    <div class="home">
      <div class="heard">
        <el-form ref="form" :model="querySearch.condition" label-width="100px">
          <el-row>
            <!--            <el-col :span="9">-->
            <!--              <el-form-item label="供应商名称:">-->
            <!--                <el-input clearable v-model="querySearch.condition.supplierName"-->
            <!--                          placeholder="请输入供应商名称"></el-input>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->

            <el-col :span="8">
              <el-form-item label="商品名称:">
                <el-input clearable v-model="querySearch.condition.productName" placeholder="请输入商品名称"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="展示分类:">
                <el-select v-model="querySearch.condition.categoryFirstCode" placeholder="请选择" style="width: 100%"
                           clearable>
                  <el-option v-for="item in categoryList" :key="item.categoryCode" :label="item.categoryName"
                             :value="item.categoryCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="商品状态:">
                <el-select v-model="querySearch.condition.productStatus" placeholder="请选择"
                           style="width: 100%" clearable>
                  <el-option label="全部" :value="null"></el-option>
                  <el-option label="已上架" :value="1"></el-option>
                  <el-option label="已下架" :value="2"></el-option>
                  <el-option label="未上架" :value="0"></el-option>
                </el-select>

              </el-form-item>
            </el-col>

          </el-row>
          <el-row>


            <!--            <el-col :span="8">-->
            <!--              <el-form-item label="是否入柜:">-->
            <!--                <el-select v-model="querySearch.condition.enterCabinet" placeholder="请选择" style="width: 100%"-->
            <!--                           clearable>-->
            <!--                  <el-option label="全部" :value="3"></el-option>-->
            <!--                  <el-option label="是" :value="1"></el-option>-->
            <!--                  <el-option label="否" :value="0"></el-option>-->
            <!--                </el-select>-->

            <!--              </el-form-item>-->
            <!--            </el-col>-->

            <!--            <el-col :span="7">-->
            <!--              <el-form-item label="专享配送:">-->
            <!--                <el-select v-model="querySearch.condition.isVipDelivery" placeholder="请选择" style="width: 100%"-->
            <!--                           clearable>-->
            <!--                  <el-option label="全部" :value="3"></el-option>-->
            <!--                  <el-option label="是" :value="1"></el-option>-->
            <!--                  <el-option label="否" :value="0"></el-option>-->
            <!--                </el-select>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->

          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="创建时间:">
                <el-date-picker
                  @change="changeTime"
                  v-model="forceTime"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm"
                  :default-time="['', '23:59:00']"
                  class="custom-date-picker"
                  format="yyyy-MM-dd HH:mm"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label-width="20px">
                <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
                <el-button type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
              </el-form-item>


            </el-col>
          </el-row>

        </el-form>
      </div>
      <div class="main">
        <div class="add-box">
          <el-button type="primary" plain style="font-size: 16px" @click="addGoods">发布商品</el-button>
<!--          <el-button type="primary" plain style="font-size: 16px" @click="exportExcel">导入商品</el-button>-->
          <!-- <el-button
            type="primary"
            plain
            style="font-size: 16px;"
            @click="addGoods"
            >设置活动价格比例</el-button
          > -->
        </div>
        <div class="main-table" style="position: relative">
          <el-table :data="tableList" style="width: 100%" height="calc(100vh - 400px)" border>
            <el-table-column type="selection" width="100" align="center">
            </el-table-column>
            <el-table-column label="序号" type="index" width="80" align="center">
            </el-table-column>
            <el-table-column prop="productName" label="商品名称" width="150" align="center">
            </el-table-column>
            <el-table-column label="商品照片" align="center" width="150">
              <template slot-scope="scope">
                <el-image style="width: 50px; height: 50px" :src="scope.row.listImg"
                          :preview-src-list="[scope.row.listImg]">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="sellPrice" label="商品价格" align="center">
              <template slot-scope="scope">
                <span>¥{{ scope.row.sellPrice }}</span>
              </template>
            </el-table-column>
            <!--            <el-table-column prop="supplierName" label="供应商名称" width="200" align="center">-->
            <!--            </el-table-column>-->
            <el-table-column label="评分" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.grade ? scope.row.grade : "暂无" }}</span>
              </template>
            </el-table-column>
<!--            <el-table-column prop="isVipDelivery" label="专项配送" width="130" align="center">-->
<!--              <template slot-scope="{row}">-->
<!--                &lt;!&ndash;                <el-switch v-model="scope.row.isVipDelivery" :active-value="1" :inactive-value="0" disabled>&ndash;&gt;-->
<!--                &lt;!&ndash;                </el-switch>&ndash;&gt;-->
<!--                <el-button v-if="row.isVipDelivery == 1" type="success" plain>是</el-button>-->
<!--                <el-button v-else type="warning" plain>否</el-button>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="enterCabinet" label="是否入柜" align="center">-->
<!--              <template slot-scope="{row}">-->
<!--                &lt;!&ndash;                <el-switch v-model="scope.row.enterCabinet" :active-value="1" :inactive-value="0" disabled>&ndash;&gt;-->
<!--                &lt;!&ndash;                </el-switch>&ndash;&gt;-->
<!--                <el-button v-if="row.enterCabinet == 1" type="success" plain>是</el-button>-->
<!--                <el-button v-else type="warning" plain>否</el-button>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column prop="productStatus" label="状态" align="center" width="130">
              <template slot-scope="{ row }">
                <el-button v-if="row.productStatus == 1" type="success" plain>已上架</el-button>
                <el-button v-if="row.productStatus == 2" type="warning" plain>已下架</el-button>
                <el-button v-if="row.productStatus == 0" type="danger" plain>未上架</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160" align="center">
            </el-table-column>

            <el-table-column label="操作" width="200" align="center" fixed="right">
              <template slot-scope="{ row }">
                <div>
                  <el-button class="item-elbtn" type="text" style="color: red" v-if="row.productStatus==1  "
                             @click="forbidden(row)">
                    下架
                  </el-button>
                  <el-button class="item-elbtn" type="text" style="color: red" v-if="row.productStatus==2 "
                             @click="forbidden(row)">
                    上架
                  </el-button>
                  <el-button class="item-elbtn" type="text" style="color: red" v-if="row.productStatus==0 "
                             @click="forbidden(row)">
                    未上架
                  </el-button>

                  <el-button class="item-elbtn" type="text" size="small" @click="editProduct(row)">修改</el-button>
                  <!-- <el-button class="item-elbtn" type="text" size="small" @click="editProduct(row)"
                    >查看</el-button
                  > -->
                  <el-button class="item-elbtn" type="text" size="small" style="color: red"
                             @click="deleteProduct(row)">删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page">
          <el-pagination background layout="total, prev, pager, next" :total="count" :page-size="10"
                         @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
    </div>


    <el-dialog title="商品导入"
               :visible.sync="showExcel"
               width="40%" style="text-align:center">
      <div style="margin-bottom: 20px">
        <a style="color: #1e98d7; "
           href="https://stjnapi.duochicai.com/resources/upload/dcc/商品导入模版.xlsx">点击下载导入模板</a>
      </div>
      <el-upload
        style="width: 100%;"
        class="upload-demo"
        drag
        :action="$uploadURL"
        :http-request="uploadExcel"
        v-loading="uploadLoading"
        :file-list="fileList"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">请上传excel文件</div>
      </el-upload>

    </el-dialog>

  </div>
</template>
<script>
// import productChildren from "./components/productChildren.vue";
export default {
  components: {
    // productChildren
  },
  data() {
    return {
      activeName: 'one',
      activeTabNum: 1,
      value1: '',
      value: '',
      forceTime: [],
      querySearch: {
        condition: {
          startTime: '',
          endTime: '',
          productName: '',
          productStatus: null,
          supplierName: '',
          categoryFirstCode: '',
          enterCabinet: 3,
          isVipDelivery: 3
        },
        count: 0,
        currPage: 1,
        pageCount: 0,
        pageSize: 10
      },
      tableList: [],
      count: 0,
      categoryList: [],
      showExcel: false,
      uploadLoading: false,
      fileList: []
    }
  },
  created() {
    this.getProductList()
    this.getAllParentCategoryList()
  },
  methods: {

    exportExcel() {
      this.fileList = []
      this.showExcel = true
    },

    async uploadExcel(event) {

      this.uploadLoading = true

      const file = event.file
      // 使用 FormData 包装文件
      const formData = new FormData()
      formData.append('file', file)
      // console.log(file, 274)
      const res = await this.$http.post('/importExcel/importProduct', formData, {
        headers: {
          'Content-Type': 'multipart/form-data' // 设置正确的Content-Type
        }
      })
      if (res.data.code == 200) {
        this.uploadLoading = false
        this.$message.success(res.data.data.message)
        this.showExcel = false
        await this.getProductList()
      } else {
        this.uploadLoading = false
        this.$message.error(res.data.message)
      }
    },

    forbidden(row) {

      let productStatus = null
      if (row.productStatus == 1) {
        productStatus = 2
      } else if (row.productStatus == 2 || row.productStatus == 0) {
        productStatus = 1
      }

      this.$http
        .post('/product/upDownProduct', {
          productCode: row.productCode,
          productStatus: productStatus
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: '修改成功',
              type: 'fail'
            })
            this.getProductList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'fail'
            })
          }
        })
    },
    // 获取所有一级分类
    async getAllParentCategoryList() {
      this.$http
        .post('/productCategory/queryList', {
          level: 1
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.categoryList = res.data.data
          }
        })
    },
    changeTime(data) {
      if (data) {
        this.querySearch.condition.startTime = data[0]
        this.querySearch.condition.endTime = data[1]
      } else {
        this.querySearch.condition.startTime = ''
        this.querySearch.condition.endTime = ''
      }
      this.getProductList()
    },
    handleCurrentChange(val) {
      this.querySearch.currPage = val
      this.getProductList()
    },
    search() {
      this.querySearch.currPage = 1
      this.getProductList()
    },
    reset() {
      this.querySearch.condition.startTime = ''
      this.querySearch.condition.endTime = ''
      this.forceTime = []
      this.querySearch.condition.productName = ''
      this.querySearch.condition.productStatus = ''
      this.querySearch.condition.supplierName = ''
      this.querySearch.condition.categoryFirstCode = ''
      this.querySearch.condition.enterCabinet = 3
      this.querySearch.condition.isVipDelivery = 3
      this.querySearch.currPage = 1
      this.querySearch.pageSize = 10
      this.getProductList()
    },
    addGoods() {
      this.$router.push('/addProduct')
    },
    editProduct(row) {
      this.$router.push('/addProduct?productCode=' + row.productCode)
    },

    async getProductList() {
      let _this = this
      this.$http
        .post('/product/list', {
          ..._this.querySearch
        })
        .then(function (res) {
          let {code, data} = res.data
          if (code === 200) {
            _this.tableList = data.data
            _this.count = data.count
            _this.$forceUpdate() // 触发强制刷新
          }
        })
    },

    async deleteProduct(row) {
      let _this = this
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http
            .post('/product/delete', {
              id: row.id,
              seckillProductCode: row.seckillProductCode
            })
            .then(function (res) {
              if (res.data.code == 200) {
                _this.$message({
                  message: '删除成功!',
                  type: 'success'
                })
                _this.getProductList()
              } else {
                _this.$message({
                  message: res.data.message,
                  type: 'fail'
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  height: 100% !important;

  .home {
    height: 100% !important;
    display: flex;
    flex-direction: column;
    background-color: #eef1f6;
    padding: 10px;
    box-sizing: border-box;
  }

  .heard {
    background-color: #fff;
    height: auto;
    padding: 15px;

    .item-col {
      display: flex;
      align-items: center;
      margin-bottom: 18px;

      .label {
        width: fit-content;
        margin-right: 10px;
      }

      div {
        flex: 1;
      }
    }
  }

  .main {
    margin-top: 20px;
    flex: 1;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    padding: 15px;

    .main-table {
      flex: 1;
      overflow: hidden;
    }

    .page {
      display: flex;
      justify-content: flex-end;
    }
  }
}

/deep/ .el-tabs__nav-wrap::after {
  position: static !important;
}

/deep/ .el-tabs__active-bar {
  background-color: transparent !important;
}

/deep/ .el-tabs__nav.is-top {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: space-around;
  background-color: #dff0f9;
  overflow-y: auto;
}

/deep/ .item-elbtn {
  margin-left: 0;
  padding: 0 5px;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  /* 将按钮组对齐到右侧 */
  width: 100%;
  /* 确保按钮组占据整个宽度 */
}

.button-group .el-button {
  margin-left: 8px;
  /* 可选：调整按钮之间的间距 */
}

.item-col {
  display: flex;
  align-items: center;
  /* 垂直居中对齐 */
}

.label {
  white-space: nowrap;
  /* 确保文本不换行 */
  margin-right: 8px;
  /* 可选：添加一些间距 */
}

.date-picker-container {
  flex-grow: 1;
  /* 让容器占据剩余空间 */
  width: 100%;
  /* 确保容器宽度为100% */
}

.custom-date-picker {
  width: 100%;
  /* 设置时间选择器宽度 */
  //max-width: 340px;
  /* 可选：限制最大宽度 */
}

</style>
